import React,
{
    useState,
    useEffect
}

    from "react";

import {
    useNavigate
}

    from "react-router-dom";

/* ─────────────────────────────────────────
   AESTHETIC: "Dark Editorial Tech"
   Fonts: Syne (bold display) + Plus Jakarta Sans (warm body) + Space Mono (data)
   Colors: Indigo #6C63FF · Teal #00D4AA · Pink #FF6B9D
───────────────────────────────────────── */

const FONT_LINK = `@import url('https://fonts.googleapis.com/css2?family=Syne:wght@400;500;600;700;800&family=Plus+Jakarta+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;1,400&family=Space+Mono:wght@400;700&display=swap');
`;

const GLOBAL_CSS = ` $ {
    FONT_LINK
}

*,
*::before,
*::after {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
}

:root {
    --bg: #070810;
    --s1: #0E0F1C;
    --s2: #13152A;
    --s3: #181A30;
    --a1: #6C63FF;
    --a2: #00D4AA;
    --a3: #FF6B9D;
    --bd: rgba(255, 255, 255, 0.07);
    --bd2: rgba(255, 255, 255, 0.12);
    --w: #F0F0FF;
    --m: rgba(240, 240, 255, 0.52);
    --m2: rgba(240, 240, 255, 0.3);
    --grad: linear-gradient(135deg, #6C63FF, #00D4AA, #FF6B9D);
    --grad2: linear-gradient(135deg, #6C63FF, #00D4AA);
    --D: 'Syne', sans-serif;
    --B: 'Plus Jakarta Sans', sans-serif;
    --M: 'Space Mono', monospace;
}

html {
    scroll-behavior: smooth;
}

body {
    background: var(--bg);
    color: var(--w);
    font-family: var(--B);
    overflow-x: hidden;
    min-height: 100vh;
}

body::before {
    content: '';
    position: fixed;
    inset: 0;
    z-index: 0;
    pointer-events: none;
    background-image:
        linear-gradient(rgba(108, 99, 255, 0.04) 1px, transparent 1px),
        linear-gradient(90deg, rgba(108, 99, 255, 0.04) 1px, transparent 1px);
    background-size: 60px 60px;
}

.gt {
    background: var(--grad2);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
}

.gt3 {
    background: var(--grad);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
}

.blob {
    position: fixed;
    border-radius: 50%;
    filter: blur(100px);
    pointer-events: none;
    z-index: 0;
}

.b1 {
    width: 600px;
    height: 600px;
    background: rgba(108, 99, 255, 0.15);
    top: -200px;
    left: -150px;
}

.b2 {
    width: 400px;
    height: 400px;
    background: rgba(0, 212, 170, 0.10);
    top: 200px;
    right: -100px;
}

.b3 {
    width: 350px;
    height: 350px;
    background: rgba(255, 107, 157, 0.08);
    bottom: 100px;
    left: 35%;
}

/* NAV */
.lp-nav {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 200;
    padding: 16px 40px;
    transition: all 0.35s;
}

.lp-nav.scrolled {
    background: rgba(7, 8, 16, 0.85);
    backdrop-filter: blur(24px) saturate(180%);
    border-bottom: 0.5px solid var(--bd2);
    padding: 12px 40px;
}

.lp-nav-inner {
    max-width: 1140px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.lp-logo {
    display: flex;
    align-items: center;
    gap: 10px;
    text-decoration: none;
}

.lp-logo-mark {
    width: 36px;
    height: 36px;
    border-radius: 10px;
    background: var(--grad2);
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: var(--D);
    font-size: 17px;
    font-weight: 800;
    color: #070810;
    flex-shrink: 0;
}

.lp-logo-text {
    font-family: var(--D);
    font-size: 15px;
    font-weight: 600;
    color: var(--w);
    letter-spacing: -0.3px;
}

.lp-logo-text strong {
    font-weight: 800;
    color: var(--a2);
}

.lp-nav-links {
    display: flex;
    align-items: center;
    gap: 32px;
}

.lp-nav-link {
    font-size: 14px;
    font-weight: 500;
    color: var(--m);
    text-decoration: none;
    transition: color 0.2s;
}

.lp-nav-link:hover {
    color: var(--w);
}

.lp-theme-btn {
    width: 38px;
    height: 38px;
    border-radius: 50%;
    border: 0.5px solid var(--bd2);
    background: var(--s1);
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: border-color 0.2s, background 0.2s;
    flex-shrink: 0;
}

.lp-theme-btn:hover {
    border-color: var(--a1);
    background: rgba(108, 99, 255, 0.1);
}

.lp-nav-cta {
    padding: 10px 22px;
    border: none;
    border-radius: 8px;
    background: var(--grad2);
    color: #070810;
    font-family: var(--B);
    font-size: 13px;
    font-weight: 700;
    cursor: pointer;
    transition: opacity 0.2s, transform 0.15s;
    position: relative;
    overflow: hidden;
}

.lp-nav-cta::after {
    content: '';
    position: absolute;
    inset: 0;
    background: rgba(255, 255, 255, 0.15);
    opacity: 0;
    transition: opacity .2s;
}

.lp-nav-cta:hover {
    opacity: 0.9;
    transform: translateY(-1px);
}

.lp-nav-cta:hover::after {
    opacity: 1;
}

/* HERO */
.lp-hero-wrap {
    position: relative;
    z-index: 1;
    overflow: hidden;
}

.lp-hero {
    position: relative;
    z-index: 1;
    max-width: 1140px;
    margin: 0 auto;
    padding: 130px 40px 90px;
    display: grid;
    grid-template-columns: 1fr 420px;
    gap: 60px;
    align-items: center;
}

.lp-pill {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 5px 16px 5px 6px;
    border-radius: 100px;
    border: 0.5px solid rgba(0, 212, 170, 0.3);
    background: rgba(0, 212, 170, 0.06);
    margin-bottom: 28px;
}

.lp-pill-dot {
    width: 22px;
    height: 22px;
    border-radius: 50%;
    background: var(--grad2);
    display: flex;
    align-items: center;
    justify-content: center;
}

.lp-pill-dot::after {
    content: '';
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background: #070810;
}

.lp-pill-text {
    font-family: var(--M);
    font-size: 11px;
    color: var(--a2);
    letter-spacing: 0.5px;
}

.lp-h1 {
    font-family: var(--D);
    font-size: clamp(3.2rem, 5.8vw, 5.4rem);
    font-weight: 800;
    line-height: 1.0;
    letter-spacing: -2px;
    color: var(--w);
    margin-bottom: 24px;
}

.lp-h1 .line-grad {
    display: block;
    background: var(--grad);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
}

.lp-hero-sub {
    font-size: 16px;
    font-weight: 400;
    line-height: 1.85;
    color: var(--m);
    max-width: 460px;
    margin-bottom: 36px;
}

.lp-ctas {
    display: flex;
    gap: 12px;
    flex-wrap: wrap;
    margin-bottom: 48px;
}

.lp-btn-primary {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 14px 28px;
    border: none;
    border-radius: 10px;
    background: var(--grad2);
    color: #070810;
    font-family: var(--B);
    font-size: 14px;
    font-weight: 700;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    transition: transform 0.2s, opacity 0.2s;
}

.lp-btn-primary::after {
    content: '';
    position: absolute;
    inset: 0;
    background: rgba(255, 255, 255, 0.18);
    opacity: 0;
    transition: opacity .2s;
}

.lp-btn-primary:hover {
    transform: translateY(-2px);
}

.lp-btn-primary:hover::after {
    opacity: 1;
}

.lp-btn-ghost {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 14px 22px;
    border: 0.5px solid var(--bd2);
    border-radius: 10px;
    background: transparent;
    color: var(--m);
    font-family: var(--B);
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    text-decoration: none;
    transition: border-color 0.2s, color 0.2s;
}

.lp-btn-ghost:hover {
    border-color: rgba(108, 99, 255, 0.5);
    color: var(--w);
}

.lp-stats {
    display: flex;
    gap: 36px;
    padding-top: 32px;
    border-top: 0.5px solid var(--bd);
}

.lp-stat-n {
    font-family: var(--M);
    font-size: 28px;
    font-weight: 700;
    line-height: 1;
    background: var(--grad2);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
}

.lp-stat-l {
    font-size: 12px;
    color: var(--m2);
    margin-top: 4px;
}

/* SCENE */
.scene {
    position: relative;
    width: 380px;
    height: 460px;
    flex-shrink: 0;
}

.phone-a {
    position: absolute;
    left: 0;
    top: 60px;
    width: 155px;
    height: 270px;
    background: var(--s2);
    border-radius: 22px;
    border: 0.5px solid rgba(255, 255, 255, 0.09);
    overflow: hidden;
    z-index: 3;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.7);
    animation: pa 0.9s cubic-bezier(.34, 1.56, .64, 1) both 0.3s;
    transform: rotate(-6deg);
}

@keyframes pa {
    from {
        opacity: 0;
        transform: translateX(-28px) rotate(-6deg)
    }

    to {
        opacity: 1;
        transform: rotate(-6deg)
    }
}

.phone-b {
    position: absolute;
    right: 0;
    top: 0;
    width: 176px;
    height: 314px;
    background: #0D0E1A;
    border-radius: 24px;
    border: 0.5px solid rgba(108, 99, 255, 0.3);
    overflow: hidden;
    z-index: 4;
    box-shadow: 0 30px 80px rgba(0, 0, 0, 0.75), 0 0 60px rgba(108, 99, 255, 0.1);
    animation: pb 0.9s cubic-bezier(.34, 1.56, .64, 1) both 0.5s;
    transform: rotate(4deg);
}

@keyframes pb {
    from {
        opacity: 0;
        transform: translateY(28px) rotate(4deg)
    }

    to {
        opacity: 1;
        transform: rotate(4deg)
    }
}

.scanner-screen {
    width: 100%;
    height: 100%;
    background: #08090F;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 12px;
    padding: 12px;
}

.vf {
    width: 100px;
    height: 100px;
    position: relative;
    background: rgba(108, 99, 255, 0.04);
    border-radius: 10px;
}

.vc {
    position: absolute;
    width: 18px;
    height: 18px;
    border-color: var(--a1);
    border-style: solid;
}

.vc.tl {
    top: 0;
    left: 0;
    border-width: 2px 0 0 2px;
    border-radius: 4px 0 0 0
}

.vc.tr {
    top: 0;
    right: 0;
    border-width: 2px 2px 0 0;
    border-radius: 0 4px 0 0
}

.vc.bl {
    bottom: 0;
    left: 0;
    border-width: 0 0 2px 2px;
    border-radius: 0 0 0 4px
}

.vc.br {
    bottom: 0;
    right: 0;
    border-width: 0 2px 2px 0;
    border-radius: 0 0 4px 0
}

.laser {
    position: absolute;
    left: 4px;
    right: 4px;
    height: 1.5px;
    background: linear-gradient(90deg, transparent, var(--a1), transparent);
    box-shadow: 0 0 8px var(--a1);
    animation: sweep 2.2s ease-in-out infinite 1.5s;
}

@keyframes sweep {
    0% {
        top: 6px;
        opacity: 0
    }

    8% {
        opacity: 1
    }

    92% {
        opacity: 1
    }

    100% {
        top: 88px;
        opacity: 0
    }
}

.mini-qr {
    position: absolute;
    inset: 12px;
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    grid-template-rows: repeat(6, 1fr);
    gap: 2px;
}

.qrc {
    border-radius: 1px;
}

.scan-lbl {
    font-family: var(--M);
    font-size: 9px;
    color: rgba(108, 99, 255, 0.5);
    letter-spacing: 0.5px;
    text-align: center
}

.p-banner {
    width: 100%;
    height: 110px;
    background: linear-gradient(160deg, #110D2A, #1A1040);
    position: relative;
    overflow: hidden
}

.p-banner::after {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(160deg, rgba(108, 99, 255, 0.4), rgba(0, 212, 170, 0.15))
}

.p-fade {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 50px;
    background: linear-gradient(transparent, #0D0E1A);
    z-index: 1
}

.p-avatar {
    position: absolute;
    bottom: 2px;
    left: 14px;
    z-index: 2;
    width: 42px;
    height: 42px;
    border-radius: 50%;
    border: 2px solid #0D0E1A;
    background: var(--grad2);
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: var(--D);
    font-size: 13px;
    font-weight: 800;
    color: #070810;
    animation: pop .5s cubic-bezier(.34, 1.56, .64, 1) both 2.6s;
}

@keyframes pop {
    from {
        transform: scale(.3);
        opacity: 0
    }

    to {
        transform: scale(1);
        opacity: 1
    }
}

.p-reveal {
    width: 100%;
    height: 100%;
    animation: cr .7s cubic-bezier(.22, 1, .36, 1) both 2.1s
}

@keyframes cr {
    from {
        transform: translateY(36px);
        opacity: 0
    }

    to {
        transform: translateY(0);
        opacity: 1
    }
}

.p-info {
    padding: 27px 12px 10px
}

.p-name {
    font-family: var(--D);
    font-size: 14px;
    font-weight: 700;
    color: var(--w);
    margin-bottom: 2px
}

.p-name em {
    font-style: normal;
    background: var(--grad2);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text
}

.p-role {
    font-size: 8px;
    color: var(--m2);
    letter-spacing: 0.3px;
    margin-bottom: 10px
}

.p-tiles {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 4px;
    margin-bottom: 8px
}

.p-tile {
    background: rgba(255, 255, 255, 0.04);
    border: 0.5px solid rgba(255, 255, 255, 0.08);
    border-radius: 7px;
    padding: 6px 5px;
    display: flex;
    flex-direction: column;
    gap: 3px;
    animation: ti .3s ease both;
}

.p-tile:nth-child(1) {
    animation-delay: 2.7s
}

.p-tile:nth-child(2) {
    animation-delay: 2.85s
}

.p-tile:nth-child(3) {
    animation-delay: 3s
}

@keyframes ti {
    from {
        opacity: 0;
        transform: translateY(5px)
    }

    to {
        opacity: 1;
        transform: translateY(0)
    }
}

.p-tdot {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: linear-gradient(135deg, rgba(108, 99, 255, 0.25), rgba(0, 212, 170, 0.2));
    display: flex;
    align-items: center;
    justify-content: center
}

.p-tdot::after {
    content: '';
    width: 4px;
    height: 4px;
    border-radius: 50%;
    background: var(--a1)
}

.p-tlbl {
    font-size: 7px;
    color: var(--m2);
    font-weight: 500
}

.p-save {
    width: 100%;
    padding: 7px;
    border: none;
    border-radius: 7px;
    background: var(--grad2);
    color: #070810;
    font-size: 7.5px;
    font-weight: 700;
    letter-spacing: 0.3px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 3px;
    animation: ti .3s ease both 3.1s;
}

.beam-line {
    position: absolute;
    top: 165px;
    left: 148px;
    width: 86px;
    height: 1px;
    background: linear-gradient(90deg, var(--a1), transparent);
    z-index: 5;
    animation: bm .4s ease both 1.7s
}

@keyframes bm {
    from {
        transform: scaleX(0);
        transform-origin: left
    }

    to {
        transform: scaleX(1);
        transform-origin: left
    }
}

.beam-dot {
    position: absolute;
    top: 160px;
    left: 148px;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: var(--a1);
    box-shadow: 0 0 10px var(--a1);
    animation: bdot 2.2s ease-in-out infinite 1.8s;
    z-index: 6
}

@keyframes bdot {
    0% {
        left: 148px;
        opacity: 0;
        transform: scale(.5)
    }

    10% {
        opacity: 1;
        transform: scale(1)
    }

    90% {
        opacity: .9
    }

    100% {
        left: 226px;
        opacity: 0;
        transform: scale(.5)
    }
}

/* DIVIDER */
.lp-div {
    height: 0.5px;
    background: linear-gradient(90deg, transparent, rgba(108, 99, 255, 0.3), rgba(0, 212, 170, 0.2), transparent)
}

/* TRUST */
.lp-trust {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 24px;
    flex-wrap: wrap;
    padding: 20px 40px;
    background: rgba(255, 255, 255, 0.015);
}

.lp-trust-lbl {
    font-family: var(--M);
    font-size: 10px;
    color: var(--m2);
    letter-spacing: 1.5px;
    text-transform: uppercase
}

.lp-trust-items {
    display: flex;
    align-items: center;
    gap: 20px;
    flex-wrap: wrap
}

.lp-trust-item {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 13px;
    font-weight: 500;
    color: var(--m)
}

.lp-trust-sep {
    color: rgba(108, 99, 255, 0.35);
    font-size: 14px
}

/* SECTIONS */
.lp-sec {
    position: relative;
    z-index: 1;
    padding: 80px 40px
}

.lp-inner {
    max-width: 1140px;
    margin: 0 auto
}

.lp-eyebrow {
    display: block;
    text-align: center;
    font-family: var(--M);
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 2px;
    text-transform: uppercase;
    background: var(--grad);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    margin-bottom: 16px;
}

.lp-h2 {
    font-family: var(--D);
    font-size: clamp(2.2rem, 4.5vw, 3.5rem);
    font-weight: 800;
    line-height: 1.06;
    letter-spacing: -1.2px;
    color: var(--w);
    text-align: center;
    margin-bottom: 14px;
}

.lp-sub {
    font-size: 15px;
    font-weight: 400;
    color: var(--m);
    text-align: center;
    max-width: 480px;
    margin: 0 auto 48px;
    line-height: 1.9;
}

/* STEPS */
.lp-steps {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 1px;
    background: var(--bd);
    border-radius: 20px;
    overflow: hidden;
}

.lp-step {
    background: var(--s1);
    padding: 36px 28px;
    position: relative;
    overflow: hidden;
    transition: background .3s;
    cursor: default;
}

.lp-step:hover {
    background: var(--s2)
}

.lp-step::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 2px;
    background: var(--grad2);
    transform: scaleX(0);
    transform-origin: left;
    transition: transform .4s;
}

.lp-step:hover::before {
    transform: scaleX(1)
}

.lp-step-num {
    position: absolute;
    top: 20px;
    right: 20px;
    font-family: var(--M);
    font-size: 40px;
    font-weight: 700;
    color: rgba(255, 255, 255, 0.04);
    line-height: 1;
}

.lp-step-icon {
    width: 48px;
    height: 48px;
    border-radius: 14px;
    background: linear-gradient(135deg, rgba(108, 99, 255, 0.15), rgba(0, 212, 170, 0.1));
    border: 0.5px solid rgba(108, 99, 255, 0.25);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 22px;
    margin-bottom: 20px;
}

.lp-step-title {
    font-family: var(--D);
    font-size: 22px;
    font-weight: 700;
    color: var(--w);
    margin-bottom: 10px;
    letter-spacing: -0.3px
}

.lp-step-desc {
    font-size: 14px;
    color: var(--m);
    line-height: 1.8
}

/* FEATURES */
.lp-feat-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 1px;
    background: var(--bd);
    border-radius: 20px;
    overflow: hidden;
}

.lp-feat {
    background: var(--s1);
    padding: 28px 22px;
    transition: background .25s
}

.lp-feat:hover {
    background: var(--s2)
}

.lp-feat:hover .lp-feat-icon {
    transform: scale(1.1) rotate(-5deg)
}

.lp-feat-icon {
    font-size: 26px;
    margin-bottom: 16px;
    display: block;
    transition: transform .25s
}

.lp-feat-title {
    font-family: var(--D);
    font-size: 18px;
    font-weight: 700;
    color: var(--w);
    margin-bottom: 8px
}

.lp-feat-desc {
    font-size: 13px;
    color: var(--m);
    line-height: 1.85
}

/* USE CASES */
.lp-use-tabs {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    justify-content: center;
    margin-bottom: 32px
}

.lp-use-tab {
    padding: 8px 16px;
    border-radius: 100px;
    font-family: var(--B);
    font-size: 13px;
    font-weight: 500;
    cursor: pointer;
    transition: all .2s;
    border: 0.5px solid rgba(255, 255, 255, 0.08);
    background: transparent;
    color: var(--m);
}

.lp-use-tab.active {
    border-color: rgba(108, 99, 255, 0.5);
    background: rgba(108, 99, 255, 0.12);
    color: #B0A6FF
}

.lp-use-panel {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 40px;
    align-items: center;
    background: var(--s1);
    border: 0.5px solid rgba(108, 99, 255, 0.2);
    border-radius: 22px;
    padding: 44px;
    position: relative;
    overflow: hidden;
}

.lp-use-panel::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 2px;
    background: var(--grad)
}

.lp-use-badge {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 5px 14px;
    border-radius: 100px;
    margin-bottom: 18px;
    background: rgba(108, 99, 255, 0.1);
    color: #B0A6FF;
    border: 0.5px solid rgba(108, 99, 255, 0.25);
    font-size: 12px;
    font-weight: 600;
}

.lp-use-tagline {
    font-family: var(--D);
    font-size: 30px;
    font-weight: 800;
    color: var(--w);
    line-height: 1.1;
    margin-bottom: 12px;
    letter-spacing: -0.5px
}

.lp-use-desc {
    font-size: 14px;
    color: var(--m);
    line-height: 1.9;
    margin-bottom: 24px
}

.lp-use-hls {
    display: flex;
    flex-direction: column;
    gap: 10px
}

.lp-hl {
    display: flex;
    align-items: center;
    gap: 12px;
    background: var(--s2);
    border: 0.5px solid var(--bd);
    border-radius: 12px;
    padding: 14px 16px;
    transition: border-color .2s;
}

.lp-hl:hover {
    border-color: rgba(108, 99, 255, 0.3)
}

.lp-hl-chk {
    width: 26px;
    height: 26px;
    border-radius: 50%;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(135deg, rgba(108, 99, 255, 0.2), rgba(0, 212, 170, 0.15));
    border: 0.5px solid rgba(0, 212, 170, 0.25);
    font-size: 11px;
    font-weight: 700;
    color: var(--a2);
}

.lp-hl-txt {
    font-size: 13px;
    font-weight: 500;
    color: rgba(240, 240, 255, 0.7)
}

/* PRICING */
.lp-price-wrap {
    display: flex;
    justify-content: center
}

.lp-price-card {
    background: var(--s1);
    border: 0.5px solid rgba(108, 99, 255, 0.3);
    border-radius: 28px;
    padding: 44px 40px;
    width: 100%;
    max-width: 440px;
    text-align: center;
    position: relative;
    overflow: hidden;
}

.lp-price-card::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 2px;
    background: var(--grad)
}

.lp-price-card::after {
    content: '';
    position: absolute;
    top: -80px;
    left: 50%;
    transform: translateX(-50%);
    width: 280px;
    height: 200px;
    background: radial-gradient(circle, rgba(108, 99, 255, 0.12), transparent 70%);
    pointer-events: none;
}

.lp-price-badge {
    display: inline-block;
    background: var(--grad2);
    color: #070810;
    border-radius: 100px;
    padding: 5px 16px;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.5px;
    text-transform: uppercase;
    margin-bottom: 24px;
    position: relative;
    z-index: 1;
}

.lp-price-num {
    font-family: var(--D);
    font-size: 82px;
    font-weight: 800;
    line-height: 1;
    letter-spacing: -4px;
    background: var(--grad);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    position: relative;
    z-index: 1;
}

.lp-price-period {
    font-family: var(--M);
    font-size: 11px;
    color: var(--m2);
    letter-spacing: 2px;
    text-transform: uppercase;
    margin: 8px 0 28px;
    position: relative;
    z-index: 1;
}

.lp-price-list {
    list-style: none;
    text-align: left;
    margin-bottom: 28px
}

.lp-price-item {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 0;
    font-size: 14px;
    font-weight: 500;
    color: rgba(240, 240, 255, 0.72);
    border-bottom: 0.5px solid var(--bd);
}

.lp-price-chk {
    background: var(--grad2);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    font-size: 13px;
    flex-shrink: 0
}

/* CTA */
.lp-cta {
    padding: 80px 40px;
    text-align: center;
    position: relative;
    z-index: 1;
}

.lp-cta::before {
    content: '';
    position: absolute;
    inset: 0;
    background: radial-gradient(ellipse 80% 70% at 50% 50%, rgba(108, 99, 255, 0.1), rgba(0, 212, 170, 0.04) 40%, transparent 70%);
    pointer-events: none;
}

.lp-cta-title {
    font-family: var(--D);
    font-size: clamp(3rem, 7vw, 5.5rem);
    font-weight: 800;
    line-height: 1.0;
    letter-spacing: -2px;
    color: var(--w);
    margin-bottom: 20px;
}

.lp-cta-sub {
    font-size: 16px;
    color: var(--m);
    margin-bottom: 36px;
    line-height: 1.8
}

/* FOOTER */
.lp-footer {
    padding: 32px 40px 48px;
    border-top: 0.5px solid var(--bd);
    position: relative;
    z-index: 1
}

.lp-footer-inner {
    max-width: 1140px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
}

.lp-footer-tag {
    font-size: 13px;
    color: var(--m2)
}

.lp-footer-copy {
    font-size: 12px;
    color: rgba(240, 240, 255, 0.15)
}

/* REVEAL */
.reveal {
    opacity: 0;
    transform: translateY(20px);
    transition: opacity .65s ease, transform .65s ease
}

.reveal.visible {
    opacity: 1;
    transform: translateY(0)
}

/* LIGHT THEME */
.lp-light {
    --bg: #F4F5FB;
    --s1: #FFFFFF;
    --s2: #F0F1FA;
    --bd: rgba(0, 0, 0, 0.07);
    --bd2: rgba(0, 0, 0, 0.12);
    --w: #0A0B14;
    --m: rgba(10, 11, 20, 0.55);
    --m2: rgba(10, 11, 20, 0.35);
    --a1: #5249CC;
    --a2: #009980;
    --a3: #CC4480;
    --grad2: linear-gradient(135deg, #5249CC, #009980);
    --grad: linear-gradient(135deg, #5249CC, #009980, #CC4480);
}

.lp-light {
    background: var(--bg);
    color: var(--w)
}

.lp-light .b1 {
    background: rgba(82, 73, 204, 0.1)
}

.lp-light .b2 {
    background: rgba(0, 153, 128, 0.07)
}

.lp-light .b3 {
    background: rgba(204, 68, 128, 0.06)
}

.lp-light .lp-nav.scrolled {
    background: rgba(244, 245, 251, 0.9)
}

.lp-light .phone-a,
.lp-light .phone-b {
    filter: none
}

.lp-light .lp-trust {
    background: rgba(0, 0, 0, 0.025)
}

.lp-light .lp-use-panel,
.lp-light .lp-price-card {
    background: var(--s1)
}

.lp-light .lp-hl,
.lp-light .lp-step,
.lp-light .lp-feat {
    background: var(--s1)
}

.lp-light .lp-step:hover,
.lp-light .lp-feat:hover,
.lp-light .lp-hl:hover {
    background: var(--s2)
}

.lp-light .lp-btn-ghost {
    color: rgba(10, 11, 20, 0.5);
    border-color: rgba(0, 0, 0, 0.15)
}

.lp-light .lp-btn-ghost:hover {
    color: var(--w);
    border-color: rgba(82, 73, 204, 0.4)
}

/* MOBILE */
@media(max-width:900px) {
    .lp-hero {
        grid-template-columns: 1fr;
        text-align: center;
        padding: 100px 24px 60px
    }

    .lp-hero-sub,
    .lp-stats {
        margin-left: auto;
        margin-right: auto
    }

    .lp-ctas {
        justify-content: center
    }

    .lp-stats {
        justify-content: center
    }

    .lp-hero-right {
        margin-top: 32px;
        display: flex;
        justify-content: center
    }

    .scene {
        transform: scale(0.82)
    }

    .lp-steps {
        grid-template-columns: 1fr
    }

    .lp-feat-grid {
        grid-template-columns: 1fr 1fr
    }

    .lp-use-panel {
        grid-template-columns: 1fr;
        padding: 28px
    }

    .lp-nav {
        padding: 12px 24px
    }

    .lp-nav.scrolled {
        padding: 10px 24px
    }

    .lp-sec {
        padding: 60px 24px
    }

    .lp-use-tagline {
        font-size: 24px
    }

    .lp-cta {
        padding: 60px 24px
    }
}

@media(max-width:600px) {
    .lp-feat-grid {
        grid-template-columns: 1fr
    }

    .lp-h1 {
        font-size: 2.8rem
    }

    .lp-nav-link {
        display: none
    }
}

`;

const QR_PATTERN = [[1,
    1,
    1,
    0,
    1,
    0],
[1,
    0,
    1,
    1,
    0,
    1],
[1,
    1,
    1,
    0,
    1,
    1],
[0,
    1,
    0,
    1,
    0,
    0],
[1,
    0,
    1,
    1,
    1,
    0],
[0,
    1,
    0,
    0,
    1,
    1],
];

function ScanScene() {
    return (<div className="scene" > <div className="phone-a" > <div className="scanner-screen" > <div className="vf" > <div className="vc tl" /><div className="vc tr" /> <div className="vc bl" /><div className="vc br" /> <div className="laser" /> <div className="mini-qr" > {
        QR_PATTERN.map((row, ri) => row.map((c, ci) => (<div key={
            `$ {
                                ri
                            }

                            -$ {
                                ci
                            }

                            `
        }

            className="qrc"

            style={
                {
                    background: c ? "rgba(108,99,255,0.6)" : "transparent"
                }
            }

        />)))
    }

    </div> </div> <div className="scan-lbl" >SCAN TO CONNECT</div> </div> </div> <div className="beam-line" /> <div className="beam-dot" /> <div className="phone-b" > <div className="p-reveal" > <div className="p-banner" > <div className="p-fade" /> <div className="p-avatar" >UN</div> </div> <div className="p-info" > <div className="p-name" >User <em>Name</em></div> <div className="p-role" >Director · Company Name</div> <div className="p-tiles" > {
        ["Phone", "Email", "Delhi"].map(l => (<div className="p-tile" key={
            l
        }

        > <div className="p-tdot" /><div className="p-tlbl" > {
            l
        }

            </div> </div>))
    }

    </div> <button className="p-save" >↓ Save Contact</button> <div className="p-tiles" style={
        {
            marginTop: "8px"
        }
    }

    > {
                ["Website", "Resume", "Social"].map((l, i) => (<div className="p-tile" key={
                    l
                }

                    style={
                        {
                            animationDelay: `$ {
                                3.2+i*0.15
                            }

                            s`
                        }
                    }

                > <div className="p-tdot" /><div className="p-tlbl" > {
                    l
                }

                    </div> </div>))
            }

        </div> </div> </div> </div> </div>);
}

const USE_CASES = [{
    icon: "👔", role: "Job Seekers", tagline: "Land your next opportunity faster",
    desc: "Walk into every interview with a digital card that includes your resume, LinkedIn, GitHub, and portfolio — all in one elegant scan.",
    hl: ["Resume attached & downloadable", "LinkedIn & GitHub links", "QR code for instant sharing", "Save contact in one tap"]
}

    ,
{
    icon: "💼", role: "Freelancers", tagline: "Win clients before you speak",
    desc: "Share everything a client needs — portfolio, social proof, and contact — in a single professional link. Close deals faster.",
    hl: ["Portfolio & website link", "WhatsApp quick contact", "Instagram & social proof", "Professional digital presence"]
}

    ,
{
    icon: "🏢", role: "Business Owners", tagline: "Network smarter, not harder",
    desc: "Stop spending on printed cards that get lost. Share via QR at events — always updated, never outdated.",
    hl: ["Always up-to-date details", "Google Wallet for offline use", "QR code for events & meetups", "Share via WhatsApp or email"]
}

    ,
{
    icon: "🎓", role: "Students", tagline: "Build your identity early",
    desc: "Stand out in campus placements. Show your skills, projects, and social profiles before you say a word.",
    hl: ["GitHub & project links", "Resume upload for placements", "LinkedIn profile showcase", "Free forever — no cost"]
}

    ,
{
    icon: "🧑‍💻", role: "Developers", tagline: "Your entire dev profile in one link",
    desc: "GitHub, LinkedIn, Twitter, personal site, resume — all in one clean card. Share at hackathons or open source communities.",
    hl: ["GitHub & portfolio links", "Twitter / X profile", "Resume for job applications", "Professional dev identity"]
}

    ,
];

function UseCases({
    navigate

}) {
    const [active,
        setActive] = useState(0);
    const cur = USE_CASES[active];

    return (<section className="lp-sec" > <div className="lp-inner" > <span className="lp-eyebrow reveal" >Who is it for</span> <h2 className="lp-h2 reveal" >Built for every <span className="gt" >professional</span></h2> <p className="lp-sub reveal" >Whether you're a student or a CEO — your digital card works for you.</p>
        <div className="lp-use-tabs reveal" > {
            USE_CASES.map((u, i) => (<button key={
                i
            }

                className={
                    `lp-use-tab$ {
                            i===active?" active":""
                        }

                        `
                }

                onClick={
                    () => setActive(i)
                }

            > {
                    u.icon
                }

                {
                    u.role
                }

            </button>))
        }

        </div> <div className="lp-use-panel" > <div> <div className="lp-use-badge" ><span> {
            cur.icon
        }

        </span><span> {
            cur.role
        }

            </span></div> <div className="lp-use-tagline" > {
                cur.tagline
            }

            </div> <p className="lp-use-desc" > {
                cur.desc
            }

            </p> <button className="lp-btn-primary" onClick={
                () => navigate("/create")
            }

            > Create My Card — Free → </button> </div> <div className="lp-use-hls" > {
                cur.hl.map((h, i) => (<div className="lp-hl" key={
                    i
                }

                > <div className="lp-hl-chk" >✓</div> <span className="lp-hl-txt" > {
                    h
                }

                    </span> </div>))
            }

            </div> </div> </div> </section>);
}

export default function Viewone() {
    const navigate = useNavigate();
    const [scrolled,
        setScrolled] = useState(false);
    const [isLight,
        setIsLight] = useState(false);

    useEffect(() => {
        const fn = () => setScrolled(window.scrollY > 40);
        window.addEventListener("scroll", fn);
        return () => window.removeEventListener("scroll", fn);
    }

        , []);

    useEffect(() => {
        const els = document.querySelectorAll(".reveal");

        const obs = new IntersectionObserver(e => e.forEach(x => {
            if (x.isIntersecting) x.target.classList.add("visible")

        }),
            {
                threshold: 0.1
            });
        els.forEach(el => obs.observe(el));
        return () => obs.disconnect();
    }

        , []);

    const ThemeIcon = () => isLight ? (<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke={
        isLight ? "#5249CC" : "#6C63FF"
    }

        strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" > <circle cx="12" cy="12" r="5" /> <line x1="12" y1="1" x2="12" y2="3" /><line x1="12" y1="21" x2="12" y2="23" /> <line x1="4.22" y1="4.22" x2="5.64" y2="5.64" /><line x1="18.36" y1="18.36" x2="19.78" y2="19.78" /> <line x1="1" y1="12" x2="3" y2="12" /><line x1="21" y1="12" x2="23" y2="12" /> <line x1="4.22" y1="19.78" x2="5.64" y2="18.36" /><line x1="18.36" y1="5.64" x2="19.78" y2="4.22" /> </svg>) : (<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#6C63FF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" > <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" /> </svg>);

    return (<div className={
        isLight ? "lp-light" : ""
    }

        style={
            {
                background: isLight ? "#F4F5FB" : "#070810", minHeight: "100vh"
            }
        }

    > <style dangerouslySetInnerHTML={
        {
            __html: GLOBAL_CSS
        }
    }

        /> <div className="blob b1" /><div className="blob b2" /><div className="blob b3" /> {
            /* NAV */
        }

        <nav className={
            `lp-nav$ {
            scrolled?" scrolled":""
        }

        `
        }

        > <div className="lp-nav-inner" > <a href="/" className="lp-logo" > <div className="lp-logo-mark" >M</div> <span className="lp-logo-text" >myprofile<strong>corner</strong></span> </a> <div className="lp-nav-links" > <a href="#how" className="lp-nav-link" >How it works</a> <a href="#features" className="lp-nav-link" >Features</a> <a href="#pricing" className="lp-nav-link" >Pricing</a> <button className="lp-theme-btn" onClick={
            () => setIsLight(p => !p)
        }

            aria-label="Toggle theme" > <ThemeIcon /> </button> <button className="lp-nav-cta" onClick={
                () => navigate("/create")
            }

            >Create Free Card</button> </div> </div> </nav> {
            /* HERO */
        }

        <div className="lp-hero-wrap" > <div className="lp-hero" > <div> <div className="lp-pill" > <div className="lp-pill-dot" /> <span className="lp-pill-text" >100% FREE · NO APP NEEDED</span> </div> <h1 className="lp-h1" > Your Digital<br /> Identity, <br /> <span className="line-grad" >Always Ready.</span> </h1> <p className="lp-hero-sub" > Replace paper visiting cards with a smart digital card. Share your profile instantly via QR code, link, or Google Wallet — no printing, no waste. </p> <div className="lp-ctas" > <button className="lp-btn-primary" onClick={
            () => navigate("/create")
        }

        > Create My Card — It's Free →
        </button> <a href="#how" className="lp-btn-ghost" >See how it works</a> </div> <div className="lp-stats" > {
            [["100%", "Free forever"], ["2 min", "Setup time"], ["0", "Paper waste"]].map(([n, l]) => (<div key={
                l
            }

            > <div className="lp-stat-n" > {
                n
            }

                </div> <div className="lp-stat-l" > {
                    l
                }

                </div> </div>))
        }

            </div> </div> <div style={
                {
                    display: "flex", alignItems: "center", justifyContent: "center"
                }
            }

            > <ScanScene /> </div> </div> </div> <div className="lp-div" /> {
            /* TRUST */
        }

        <div className="lp-trust" > <span className="lp-trust-lbl" >Works seamlessly with</span> <div className="lp-trust-items" > {
            [["🔥", "Firebase"], ["🪙", "Google Wallet"], ["📱", "Android & iOS"], ["🔗", "Any Browser"]].map(([icon, label], i, arr) => (<React.Fragment key={
                label
            }

            > <div className="lp-trust-item" ><span> {
                icon
            }

            </span><span> {
                label
            }

                    </span></div> {
                    i < arr.length - 1 && <span className="lp-trust-sep" >·</span>
                }

            </React.Fragment>))
        }

        </div> </div> <div className="lp-div" /> {
            /* HOW IT WORKS */
        }

        <section id="how" className="lp-sec" > <div className="lp-inner" > <span className="lp-eyebrow reveal" >How it works</span> <h2 className="lp-h2 reveal" >From setup to sharing <span className="gt" >in 3 steps</span></h2> <p className="lp-sub reveal" >No app downloads. No tech skills required. Just fill, share, impress.</p> <div className="lp-steps reveal" > {
            [{
                num: "01", icon: "✏️", title: "Fill your profile", desc: "Add your name, photo, contact details, social links, resume, and website. Takes less than 2 minutes."
            }

                ,
            {
                num: "02", icon: "🎴", title: "Get your digital card", desc: "Instantly receive a beautiful card with a unique QR code and shareable link — no design skills needed."
            }

                ,
            {
                num: "03", icon: "🚀", title: "Share anywhere", desc: "Show your QR in meetings, add to Google Wallet, or send your link on WhatsApp, email, or LinkedIn."
            }

                ,
            ].map(s => (<div className="lp-step" key={
                s.num
            }

            > <div className="lp-step-num" > {
                s.num
            }

                </div> <div className="lp-step-icon" > {
                    s.icon
                }

                </div> <div className="lp-step-title" > {
                    s.title
                }

                </div> <p className="lp-step-desc" > {
                    s.desc
                }

                </p> </div>))
        }

        </div> </div> </section> <div className="lp-div" /> {
            /* FEATURES */
        }

        <section id="features" className="lp-sec" > <div className="lp-inner" > <span className="lp-eyebrow reveal" >Features</span> <h2 className="lp-h2 reveal" >Everything a modern <span className="gt" >professional</span> needs</h2> <div className="lp-feat-grid reveal" > {
            [{
                icon: "📸", title: "Profile Photo", desc: "Upload your photo — it appears on your card and in your Google Wallet pass."
            }

                ,
            {
                icon: "🔗", title: "All Social Links", desc: "LinkedIn, GitHub, Instagram, Twitter, WhatsApp, YouTube — show what matters."
            }

                ,
            {
                icon: "📄", title: "Resume Attachment", desc: "Attach your PDF resume. Recruiters can download it instantly."
            }

                ,
            {
                icon: "🪙", title: "Google Wallet", desc: "Add your card to Google Wallet and show it offline anytime, anywhere."
            }

                ,
            {
                icon: "📲", title: "QR Code", desc: "Every card gets a unique QR code. One scan opens your full profile instantly."
            }

                ,
            {
                icon: "💾", title: "Save Contact", desc: "Visitors can save your details directly to their phone contacts with one tap."
            }

                ,
            {
                icon: "✏️", title: "Edit Anytime", desc: "Changed jobs? New number? Update instantly — the link stays the same."
            }

                ,
            {
                icon: "🌐", title: "Works Everywhere", desc: "Opens in any browser on any device. No app install required."
            }

                ,
            ].map(f => (<div className="lp-feat" key={
                f.title
            }

            > <span className="lp-feat-icon" > {
                f.icon
            }

                </span> <div className="lp-feat-title" > {
                    f.title
                }

                </div> <p className="lp-feat-desc" > {
                    f.desc
                }

                </p> </div>))
        }

        </div> </div> </section> <div className="lp-div" /> <UseCases navigate={
            navigate
        }

        /> <div className="lp-div" /> {
            /* PRICING */
        }

        <section id="pricing" className="lp-sec" > <div className="lp-inner" > <span className="lp-eyebrow reveal" >Pricing</span> <h2 className="lp-h2 reveal" >Simple, <span className="gt" >honest</span> pricing</h2> <p className="lp-sub reveal" >No hidden charges. No credit card needed.</p> <div className="lp-price-wrap reveal" > <div className="lp-price-card" > <div className="lp-price-badge" >Most Popular</div> <div className="lp-price-num" >₹0</div> <div className="lp-price-period" >Forever Free</div> <ul className="lp-price-list" > {

            ["1 Digital Visiting Card", "Unique QR Code & Link", "Profile Photo Upload",
                "Resume Upload", "All Social Media Links", "Google Wallet Pass",
                "Save Contact (.vcf)", "Edit Anytime", "No App Required"].map(item => (<li className="lp-price-item" key={
                    item
                }

                > <span className="lp-price-chk" >✦</span> {
                        item
                    }

                </li>))
        }

        </ul> <button className="lp-btn-primary" style={
            {
                width: "100%", justifyContent: "center"
            }
        }

            onClick={
                () => navigate("/create")
            }

        > Get Started Free → </button> </div> </div> </div> </section> <div className="lp-div" /> {
            /* CTA */
        }

        <div className="lp-cta" > <h2 className="lp-cta-title reveal" > Stop carrying<br /> <span className="gt3" >paper cards.</span> </h2> <p className="lp-cta-sub reveal" >Create your digital card in under 2 minutes. Free, forever.</p> <button className="lp-btn-primary reveal" style={
            {
                margin: "0 auto"
            }
        }

            onClick={
                () => navigate("/create")
            }

        > Create My Card Now → </button> </div> <div className="lp-div" /> {
            /* FOOTER */
        }

        <footer className="lp-footer" > <div className="lp-footer-inner" > <a href="/" className="lp-logo" style={
            {
                textDecoration: "none"
            }
        }

        > <div className="lp-logo-mark" >M</div> <span className="lp-logo-text" >myprofile<strong>corner</strong></span> </a> <p className="lp-footer-tag" >Your digital identity, always in your pocket.</p> <p className="lp-footer-copy" >© {
            new Date().getFullYear()
        }

                MyProfileCorner · Made with ♥ in India</p> </div> </footer> </div>);
}